import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Import each language file
import en from "./Eng.json";
import hi from "./Hin.json";
import ar from "./Arb.json";
// import translationData from "./translation.json"; // your JSON file
// import translationData from "./translation.json"; // your JSON file

i18n
  .use(initReactI18next)
  .init({
    // resources: translationData,
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      ar: { translation: ar },
    },
    lng: localStorage.getItem("Lang") || "en", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
